import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rate-request-in-header text-left" }
const _hoisted_2 = { class: "chat-form stepped d-flex align-items-center" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "text-nowrap text-right" }

import ReviewValue from "~/chat/vue/widget/tabs/reviews/ReviewValue.vue";
import {useRateRequest} from "~/chat/vue/widget/tabs/chat/useRateRequest";
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "RateRequestInChat"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let {hide, system, onInput} = useRateRequest();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "filler text-truncate",
        title: _unref(__)('RATE_OUR_WORK')
      }, _toDisplayString(_unref(__)("RATE_OUR_WORK")) + ":", 9, _hoisted_3),
      _createElementVNode("span", _hoisted_4, [
        _createVNode(ReviewValue, {
          class: "value",
          "onUpdate:modelValue": _unref(onInput),
          system: _unref(system),
          "model-is-listening": ""
        }, null, 8, ["onUpdate:modelValue", "system"])
      ])
    ])
  ]))
}
}

})